var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { ApiService } from '../app/api.service';
import { CommonService } from './common.service';
import { TokenService } from '../app/tokenService.service';
var ScormCourseComponent = (function () {
    function ScormCourseComponent(router, route, apiService, platformLocation, commonService, tokenService) {
        this.router = router;
        this.route = route;
        this.apiService = apiService;
        this.platformLocation = platformLocation;
        this.commonService = commonService;
        this.tokenService = tokenService;
        this.courseList = [6001]; //智能陪练课程数组，用于判断是否跳转到智能陪练去,以后有了新课就加在这个数组里
    }
    ScormCourseComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.setTokenAndUserId()];
                    case 1:
                        _a.sent();
                        this.apiService.setHeaders(); //header设置
                        console.log('进入scorm-course');
                        this.route.params.subscribe(function (params) {
                            console.log('params', params);
                            var learningPathMetaId = params['learningPathMetaId'];
                            if (learningPathMetaId === '' || learningPathMetaId === undefined) {
                                console.error('未找到learningPathMetaId');
                                return;
                            }
                            else {
                                if (learningPathMetaId.includes(_this.courseList)) {
                                    _this.getOrCreateLearningPath(String(learningPathMetaId)).then(function (res) {
                                        var exerciseIds = params['exerciseIds'] ? params['exerciseIds'] : '';
                                        _this.platformLocation['location']['href'] = window.location.origin + '/ai/aicoach/list/' + learningPathMetaId + '?device=pc' + ("&exerciseIds=" + exerciseIds) + '&transtalent_token=' + _this.tokenService.findToken();
                                    });
                                }
                                else {
                                    var link_1;
                                    if (Number(learningPathMetaId) !== 0) {
                                        console.log('开始跳转learning-path');
                                        link_1 = ['learning-path', learningPathMetaId];
                                        // 使用 replaceUrl 替换当前 history 记录，避免新增一条浏览器返回记录
                                        _this.router.navigate(link_1, { replaceUrl: true });
                                    }
                                    else {
                                        console.log('开始跳转survey');
                                        _this.apiService.ajax({
                                            'type': 'get',
                                            'url': '/sr/v2/learningtournew'
                                        }).toPromise().then((function (res) {
                                            link_1 = ['survey', res.tour_id, 1, 2];
                                            _this.commonService.setStorage('dnaReturnUrl', location.href);
                                            // 使用 replaceUrl 替换当前 history 记录，避免新增一条浏览器返回记录
                                            _this.router.navigate(link_1, { replaceUrl: true });
                                        }));
                                    }
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ScormCourseComponent.prototype.ngAfterViewInit = function () {
    };
    // 根据learningPathMetaId创建或者获取LearningPath
    ScormCourseComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/' + learningPathMetaId
        }).toPromise();
    };
    return ScormCourseComponent;
}());
export { ScormCourseComponent };



// WEBPACK FOOTER //
// ./src/app/scorm-course.component.ts.pre-build-optimizer.js